import api from './api';
import { TabelaBensParcela } from '../interfaces/tabelasBensParcela';

const getAllTabelaParcelas = (id: number) => api.get<TabelaBensParcela[]>(`/v1/tabelas-venda/${id}/calculado`)

export const GetRelatorio = {
    getAllTabelaParcelas,
}